import defaultTokens, {
  type TopLevelNavTokens,
} from '@agria/theme/src/components/headers/topLevelNav/tokens';

const tokens: TopLevelNavTokens = {
  ...defaultTokens,
  accountDivider: true,
  accountIcon: true,
} as const;

export default tokens;
